import { connect } from "react-redux";
import { Actions as NOTIFICATION_ACTIONS } from "../../store/actions/notificationActions";
import Spinner from "../common/Spinner";

const NotificationSync = ({ getNotifications, jurisdiction, loading, getDPSNotifications }) => {
	return (
		<button
			type="button"
			disabled={loading}
			className="btn btn-primary pull-right"
			onClick={() => {
				switch (jurisdiction) {
					case "UK":
						// once done this should auto-trigger the notification update
						getDPSNotifications();
						break;
					default:
						getNotifications();
				}
			}}
		>
			Get{loading ? "ting" : ""} New Notifications
			{loading && (
				<Spinner
					style={{ height: "1.5em", marginLeft: 5, float: "right" }}
					className="animate-spin h-5 w-5"
				/>
			)}
		</button>
	);
};

const mapStateToProps = (state) => {
	return {
		jurisdiction: state.company?.settings?.jurisdiction,
		loading: state.notifications?.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getNotifications: () => dispatch(NOTIFICATION_ACTIONS.getNotifications()),
	getDPSNotifications: () => dispatch(NOTIFICATION_ACTIONS.getDPSNotifications()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationSync);
